import React, { useEffect, useRef } from 'react';
import { Field, useField, useForm } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import PredefineActions from '../../../../../../ai-studio/predefine-actions/PredefineActions';
import usePredefineOptions from '../../../../hooks/usePredefineOptions';
import HistoryDrawer from '../history-drawer/HistoryDrawer';
import { selectedMediaSelector } from '../../../../../../redux/ai-studio/aiStudioSelectors';
import WithError from '../../../../../../components/with-error/WithError';

import scss from './ActionSelect.module.scss';

function ActionSelect() {
  const { t } = useTranslation('studio');
  const form = useForm();
  const { input: actionInput } = useField('action');

  const prevMediaType = useRef(null);

  const selectedMedia = useSelector(selectedMediaSelector);
  const actionOptions = usePredefineOptions(selectedMedia?.mediaType);

  const handleActionChange = (nextAction, currentAction) => {
    if (nextAction === currentAction) {
      return;
    }

    const { initialValues = {} } = form.getState();
    form.reset({
      ...initialValues,
      action: nextAction,
    });
  };

  useEffect(() => {
    if (selectedMedia?.mediaType !== prevMediaType.current) {
      prevMediaType.current = selectedMedia?.mediaType;
      const availableActions = actionOptions.options.flatMap((option) => option.options);
      handleActionChange(availableActions[0].value, actionInput.value);
    }
  }, [selectedMedia]);

  return (
    <div className={scss.predefineActions}>
      <span className={scss.predefineActionsTitle}>{t('chooseAnOption')}:</span>

      <div className={scss.inputWrapper}>
        <Field name='action'>
          {({ input, meta }) => (
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              <PredefineActions
                selectedOption={input.value}
                onSelectOption={(nextAction) => handleActionChange(nextAction, input.value)}
                options={actionOptions.options}
                isError={meta.touched && meta.error}
                placeholder={actionOptions.chooseAnOptionLabel}
              />
            </WithError>
          )}
        </Field>

        <div className={scss.mobileHistoryDrawer}>
          <HistoryDrawer />
        </div>
      </div>
    </div>
  );
}

export default ActionSelect;
